// extracted by mini-css-extract-plugin
export default {"table":"SPList_table__6du0A"};